import React, { useEffect, useState , useRef , useCallback, useMemo} from "react";
import { Badge, Box, Button, Card, CardContent, CircularProgress, Divider, Grid, IconButton, Paper, Skeleton, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography } from '@mui/material';
// import LinearProgressWithLabel from "../../components/linearProgreswithLabel";
import { useSelector } from 'react-redux';
import AccountSetupModal from './../../components/modals/accountSetup';
import PropertyCard from "../../components/propertyCard";
import Tabs from "../../components/tabs/tabs";
import { checkLogin, convertMsToTime, convertToIndianFormat } from "../../utils/functions";
import store from "../../redux/store";

import ProjectCard from "../../components/projectCard";
import CustomIcon from "../../components/customIcon";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import listingService from "../../services/listingServices";
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import transactionServices from "../../services/transactionServices";
import moment from "moment";
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import DataGridTable from "../../components/DataGridTabel";
import ResponsiveDataGridCards from "../../components/ResponsiveDataGridCards";
import CompletedAssets from "./completedAssets";
import listingTeaserService from "../../services/listingTeaser";
import PropertyTeaser from "../../components/proppertyTeaser";
export default function Dashboard() {
    const investorId = useSelector(state => state.user?.data?._id);

    const userState = useLocation();
    let [searchParams, setSearchParams] = useSearchParams();

    const [properties, setProperties] = useState([]);

    const [url, setUrl] = useState("");

    const navigate = useNavigate();

    const user = useSelector(state => state.user.data);


    const [width, setWidth] = useState(window.innerWidth);

    const [currentStep, setCurrentStep] = useState(null);
    const [showSignUp, setShowSignUp] = useState(false);
    const [showNotification, setShowNotification] = useState(false);
    const [ongoingTransactions, setOngoingTransactions] = useState([]);
    const [resURL, setResURL] = useState('');
    const [optinPendingTransactions, setOptinPendingTransactions] = useState([]);
    useEffect(() => {
        if (searchParams.get('show')) {
            searchParams.delete('show');
            setSearchParams(searchParams);
        }
        if (user?.status === "FIRST_TIME") setCurrentStep(0);
        if (user?.status === "REGISTERED") setCurrentStep(1);
        if (user?.status === "KYC_COMPLETE" || user?.status === "REJECTED") setCurrentStep(2);
        if (user?.status === "KYC_APPROVED") setCurrentStep(3);
        if (user?.status === "APPROVED") setCurrentStep(4);
        if (userState.state === "FIRST_TIME" || userState.state === "REGISTERED" || userState.state === "KYC_APPROVED") setShowSignUp(true);
        if (user?.status === "APPROVED") {
            let redirectUrl = localStorage.getItem("redirectUrl")
            if (redirectUrl && !showSignUp) {
                localStorage.removeItem(redirectUrl)
                navigate(redirectUrl)
            }
        }
        // eslint-disable-next-line
    }, [user?.status, showSignUp]);

    useEffect(() => {
        window.addEventListener("resize", changeWidth);

        return () => window.removeEventListener("resize", changeWidth);
    }, []);

    // useEffect(() => {
    //     getListings();
    // }, [])

    // const getListings = async () => {
    //     let res = await listingService.getApprovedListing(user._id);
    //     if (res && res.success) {
    //         if (user.membershiptype === "SELECT") {
    //             await getSelectListings(res.data, user._id);
    //         } else {
    //             setProperties(res.data);
    //             setUrl(res.url)
    //         }
    //     }
    // }

    // const getSelectListings = async (list, userId) => {
    //     const res = await listingService.getApprovedSelectListing(userId);
    //     if (res && res.success) {
    //         let propertyList = [
    //             ...res.data, ...list
    //         ]
    //         setProperties(propertyList);
    //         setUrl(res.url)
    //     }
    // }

    const changeWidth = () => {
        setWidth(window.innerWidth);
    }

    const tabs = [
        {
            name: "Properties",
            tab: <PropertiesTabPanel />
        },
        {
            name: "Projects",
            tab: <ProjectTabPanel />
        },
        // {
        //     name:"Developers",
        //     tab:<DeveloperTabPanel />
        // },
        {
            name: "Completed Assets",
            tab: <CompletedAssets />
        }
    ];

    const [activeTab, setActiveTab] = useState(0);


    const handleTabClick = (index) => {
        setActiveTab(index);
    }

    const getOngoingTransactionDetails = async (investorId) => {
        const data = {
            investorId: investorId,
            statusArray: ["CREATED"]
        }
        let res = await transactionServices.getTransactionByLisitngAndUser(data);
        if (res && res.success && res.data?.length > 0) {
            const baseURL = res.url;
            setResURL(baseURL);
            setOngoingTransactions(res.data);
        }

    }
    const getOptinPendingDetails = async (investorId) => {
        const data = {
            id: investorId,
        }
        let res = await transactionServices.getOptinPendingDetails(data);
        if (res && res.success && res.data?.length > 0) {
            let tempData = [];
            for (let e of res.data) {
               
                
                if (!e?.listingId) continue;
                let temp = {
                    propertyInfo:
                        [
                            e?.title,
                            res.url + e?.listingImages || "",
                            e.projectName,
                            e.propertyCode
                        ],
                    imgUrl: res.url + e?.listingImages || "",
                    propertyName: e?.title,
                    rightToOwnerShip: e.rightToOwnerShip ? "RCO" : "Tokenization",
                    propertyId: e.listingId,
                    projectName: e.projectName,
                    frax: e.totalNoOfFracs,
                    investAmt: e.totalAmtPaid || 0,
                    pendingAmount: (e.pendingAmt) || 0,
                    date: moment.unix(e.created_at).format("DD/MM/YYYY") || 12 / 12 / 2000,
                    uDate: moment.unix(e.created_at).format("DD/MM/YYYY") || 12 / 12 / 2000,
                    percentInvested: `${(e.totalNoOfFracs/e.listingNoOfFracs*100).toFixed(2)} %`,
                    status: e.status,
                    listingId: e.listingId,
                    projectId: e.projectId,
                    _id: e._id,
                    transactionId: e.transactionId,
                    saleDeed: res.url + (e?.listing?.registrationCertificate[0]?.docUrl || ""),
                    dltNickname: e.dltWalletName,
                    entityType: e.entityType, 
                    tokenName: e?.tokenName,
                    dltAccount: e.dltAccount,
                    assetId: e.assetId,
                };
                tempData.push(temp);    
            }
           
            setOptinPendingTransactions(tempData);

        } else {
            setOptinPendingTransactions([]);
            // enqueueSnackbar(res?.data?.message || "Something went wrong", { variant: "error" });
        }
       
    }

    useEffect(() => {
        if(investorId){
        getOngoingTransactionDetails(investorId);
        getOptinPendingDetails(investorId);
        }
    }, [investorId]);

    const customHandleClose = () => {
        setShowSignUp(false);
    }
    
    return (
        <Box>
            <AccountSetupModal handleClose={() => customHandleClose()} open={showSignUp} />
            <Grid container columnSpacing={3} rowSpacing={{ md: 3, xs: 3 }} mt={{ md: 0, xs: 2 }}>
                {
                  ( currentStep !== null && currentStep < 4) &&
                    <Grid item xs={12} md={8}>
                        <DashBoardCard
                            title={"Complete Account Setup"}
                            subtitle={"In order to have complete access to the RealX platform, you'll have to complete your account"}
                            body={
                                <Stack direction={"column"} spacing={{ md: "20px", xs: 1 }} mt={{ md: 2, xs: 1 }}>
                                    <ProfileSteps
                                        title={"Create Account"}
                                        subtitle={"You have successfully created your RealX account"}
                                        done={true}
                                    />

                                    <ProfileSteps
                                        title={"Complete Profile Details"}
                                        subtitle={currentStep <= 0 ? "Sumbit your profile details to get started" : "You have successfully submitted all the profile details."}
                                        done={currentStep > 0}
                                        active={currentStep === 0}

                                        btnProps={{
                                            title: "Create Profile",
                                            onClick: () => {
                                                setShowSignUp(true)
                                            }
                                        }}

                                    />
                                    <ProfileSteps
                                        title={"Complete KYC"}
                                        subtitle={currentStep > 2 ? "Your KYC verification has been completed." : currentStep <= 1 ? "Complete the KYC by Submitting required document details for verification." : user?.status === "REJECTED" ? "Your KYC verification has failed. Please Submit Document Details Again." : "Your details have been submitted for verification. This will be processed in 48 hours."}
                                        active={currentStep === 1 || currentStep === 2}
                                        done={currentStep > 2}
                                        completeValue={currentStep === 1 ? 0 : 100}
                                        btnProps={{
                                            title: user?.status === "REJECTED" ? "Resubmit Details" : "Submit Details",
                                            onClick: () => {
                                                setShowSignUp(true)
                                            }
                                        }}
                                        otherAction={currentStep === 2 && user?.status === "KYC_COMPLETE" ? () => {
                                            return (
                                                <Box
                                                    sx={{
                                                        borderRadius: "18px",
                                                        bgcolor: "primary.light",
                                                        padding: "12px 24px",
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        width: "fit-content",
                                                        height: "fit-content"

                                                    }}
                                                >
                                                    <Typography variant="chipText" sx={{ color: "primary.main" }}>Verfication Pending</Typography>
                                                </Box>
                                            )
                                        } : null}
                                    />
                                    <ProfileSteps
                                        title={"Create Your Digital Assets Account"}
                                        subtitle={currentStep < 4 ? "You'll need to create a new digital assets account to receive the tokens." : "You have successfully submitted all the profile details."}
                                        done={currentStep > 3}
                                        active={currentStep === 3}

                                        btnProps={{
                                            title: "Create Account",
                                            onClick: () => {
                                                setShowSignUp(true)
                                            }
                                        }}

                                    />
                                    {/* <ProfileSteps 
                                title={"Create Porfolio"}   
                                subtitle={"Start earning profits by purchasing your first piece of Real Estate"}
                                active={currentStep===3}
                                hideBar={true}
                                btnProps={{
                                    title:"Start Investing",
                                    onClick:()=>{
                                        navigate("/marketplace")
                                    }
                                }}
                            /> */}
                                </Stack>
                            }
                        />
                    </Grid>
                    // :
                    // <Grid item xs={12} md={12}>
                    // <DashBoardCard 
                    //     title={"My Properties"} 
                    //     icon={
                    //         <Box sx={{
                    //             width:{md:48,xs:32},height:{md:48,xs:32},
                    //             bgcolor:"primary.light",
                    //             borderRadius:"100%",
                    //             display:"flex",
                    //             justifyContent:"center",
                    //             alignItems:"center"
                    //         }}>
                    //             <CustomIcon name="file-document" sx={{bgcolor:"primary.main",width:{md:24,xs:16},height:{md:24,xs:16}}} />
                    //         </Box>
                    //     }
                    //     body={
                    //         <Box mt={2}>
                    //         <PropertyTable 
                    //             emptyState={
                    //                 <Box
                    //                 sx={{
                    //                     flex:1,
                    //                     width:"100%",
                    //                     // bgcolor:"red"
                    //                 }}
                    //             >
                    //                 <Stack height={"100%"} direction={"column"} alignItems={"center"} justifyContent={"center"}>
                    //                     <Box 
                    //                         sx={{
                    //                             width:{md:160,xs:88},height:{md:160,xs:88},
                    //                             bgcolor:"primary.light",
                    //                             borderRadius:"100%",
                    //                             display:"flex",
                    //                             justifyContent:"center",
                    //                             alignItems:"center",
                    //                             mt:{md:0,xs:3}
                    //                         }}
                    //                     >
                    //                         <CustomIcon name="file-document" sx={{bgcolor:"primary.main",width:{md:72,xs:32},height:{md:72,xs:32},}} />
                    //                     </Box>
                    //                     <Typography sx={{fontSize:"28px",fontWeight:500,mt:{md:4,xs:3},mb:{md:1.5,xs:0.5}}}>No Properties</Typography>
                    //                     <Typography variant="subtitle1" sx={{fontSize:"16px",fontWeight:300,mb:{md:3,xs:2}}}>You've not made any investments yet.</Typography>
                    //                     <Button onClick={()=>navigate("/marketplace")} sx={{mb:{md:0,xs:3}}} variant="contained">Explore Properties to invest</Button>
                    //                 </Stack>
                    //             </Box>
                    //             }>
                    //         </PropertyTable>
                    //         </Box>
                    //     }
                    //     />
                    // </Grid>
                }
                {/* {
                    currentStep < 4 ? 
                    <Grid item xs={12} md={4}>
                    <DashBoardCard 
                        title={"My Properties"} 
                        icon={
                            <Box sx={{
                                width:{md:48,xs:32},height:{md:48,xs:32},
                                bgcolor:"primary.light",
                                borderRadius:"100%",
                                display:"flex",
                                justifyContent:"center",
                                alignItems:"center"
                            }}>
                                <CustomIcon name="file-document" sx={{bgcolor:"primary.main",width:{md:24,xs:16},height:{md:24,xs:16}}} />
                            </Box>
                        }
                        body={
                            <PropertyTable 
                            emptyState={
                                <Box
                                sx={{
                                    flex:1,
                                    width:"100%",
                                    // bgcolor:"red"
                                }}
                            >
                                <Stack height={"100%"} direction={"column"} alignItems={"center"} justifyContent={"center"}>
                                    <Box 
                                        sx={{
                                            width:{md:160,xs:88},height:{md:160,xs:88},
                                            bgcolor:"primary.light",
                                            borderRadius:"100%",
                                            display:"flex",
                                            justifyContent:"center",
                                            alignItems:"center",
                                            mt:{md:0,xs:3}
                                        }}
                                    >
                                        <CustomIcon name="file-document" sx={{bgcolor:"primary.main",width:{md:72,xs:32},height:{md:72,xs:32},}} />
                                    </Box>
                                    <Typography sx={{fontSize:"28px",fontWeight:500,mt:{md:4,xs:3},mb:{md:1.5,xs:0.5}}}>No Properties</Typography>
                                    <Typography variant="subtitle1" sx={{fontSize:"16px",fontWeight:300,mb:{md:3,xs:2}}}>You've not made any investments yet.</Typography>
                                    <Button onClick={()=>navigate("/marketplace")} sx={{mb:{md:0,xs:3}}} variant="contained">Explore Properties to invest</Button>
                                </Stack>
                            </Box>
                            }>
                            </PropertyTable>
                            
                        }
                        />
                    </Grid>
                    :""
                } */}
                {
                    // currentStep < 3 && 
                    // <Grid item xs={12}>
                    //     <DashBoardCard 
                    //         title={"Recommended Properties"} 
                    //         subtitle={<span>Properties recommended for you</span>} 
                    //         icon={
                    //             <Box sx={{
                    //                 width:{md:48,xs:32},height:{md:48,xs:32},
                    //                 bgcolor:"primary.light",
                    //                 borderRadius:"100%",
                    //                 display:"flex",
                    //                 justifyContent:"center",
                    //                 alignItems:"center"
                    //             }}>
                    //                 <CustomIcon name="media-live" sx={{bgcolor:"primary.main",width:{md:24,xs:16},height:{md:24,xs:16}}} />
                    //             </Box>
                    //         }
                    //         toolbarBtn={()=>{
                    //             return(
                    //                 <Button onClick={()=>navigate("/marketplace")} variant="outlined">View all</Button>
                    //             )
                    //         }}
                    //         body={
                    //             <Box sx={{
                    //                 mt:5,
                    //                 position:"relative",
                    //                 marginX:"-40px",}}>
                    //                     {
                    //                         width > 900 ?
                    //                     <CustomSlider sx={{columnGap:2}}>
                    //                         {
                    //                             properties?.map((e,i)=>{
                    //                                 return(
                    //                                 <Grid item >
                    //                                     <PropertyCard data={properties[i]} url={url} />
                    //                                 </Grid>
                    //                                 )
                    //                             })
                    //                         }
                    //                     </CustomSlider>
                    //                     :
                    //                     <Grid sx={{px:5}} container rowSpacing={2.5} >
                    //                         {
                    //                             properties?.slice(0,4).map((e,i)=>{
                    //                                 return(
                    //                                 <Grid item xs={12} >
                    //                                     <PropertyCard data={properties[i]} url={url} />
                    //                                 </Grid>
                    //                                 )
                    //                             })
                    //                         }
                    //                     </Grid>
                    //                     }
                    //                 {/* <Grid container columnSpacing={2}
                    //                     sx={{
                    //                         overflow:"auto",
                    //                         flexWrap:"nowrap",
                    //                         px:5,
                    //                         "-ms-overflow-style":"none",
                    //                         scrollbarWidth:"none",
                    //                         "&::-webkit-scrollbar":{
                    //                             display: "none",
                    //                         },
                    //                         "&::-moz-scrollbar":{
                    //                             display: "none",
                    //                         },
                    //                     }}

                    //                 >
                    //                     {
                    //                         [...Array(10)].map((e)=>{
                    //                             return(
                    //                             <Grid item>
                    //                                 <PropertyCard />
                    //                             </Grid>
                    //                             )
                    //                         })
                    //                     }

                    //                 </Grid> */}
                    //             </Box>
                    //         }
                    //     />
                    // </Grid>
                }

            </Grid>
            {!showNotification && (ongoingTransactions.length > 0 || optinPendingTransactions.length > 0) && (<NotifyPaymentConfirm setShowNotification={setShowNotification} ongoingTransactions={ongoingTransactions} optinPendingTransactions={optinPendingTransactions} />)}
            {showNotification && <OngoingTransactions setShowNotification={setShowNotification} ongoingTransactions={ongoingTransactions} resURL={resURL} optinPendingTransactions={optinPendingTransactions} />}

            <Card sx={{ mt: checkLogin() ? { md: 3, xs: 2 } : { md: 15, xs: 12 }, mx: checkLogin() ? 0 : { xl: "100px", lg: "32px", md: "24px", xs: "16px" }, mb: { xl: 2, lg: 3, md: 2, xs: 0 } }}>
                <CardContent>
                    <Stack spacing={"5px"}>
                        <Stack direction={"row"} spacing={{ md: 3, xs: 1.5 }} alignItems={"center"} >
                            <Box sx={{
                                width: { md: 48, xs: 32 }, height: { md: 48, xs: 32 },
                                bgcolor: "primary.light",
                                borderRadius: "100%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center"
                            }}>
                                {/* <CircleIcon sx={{width:24,height:24}} /> */}
                                <CustomIcon name="media-live" sx={{ bgcolor: "primary.main", width: { md: 24, xs: 16 }, height: { md: 24, xs: 16 } }} />
                            </Box>
                            <Typography variant="mainCardTitle" sx={{ flex: 1 }}>Asset Listings</Typography>
                        </Stack>
                    </Stack>
                    <Stack direction={"row"} justifyContent={"space-between"}
                        sx={{
                            mt: { md: 2, xs: 0 },
                            py: 1,
                            pb: "10px",
                            pl: { md: 0, xs: 0 },
                        }}

                    >
                        <Tabs activeTab={activeTab} tabs={tabs} onClick={handleTabClick} />
                        {/* <Stack direction={"row"} spacing={2}>
            <TextField variant="outlined" placeholder="Search" InputLabelProps={{ shrink: true }} />
            <Button variant="outlined">Advanced Filters</Button>
        </Stack> */}
                    </Stack>
                    <Divider sx={{
                        width: "calc(100% + 80px)",
                        mx: -5
                    }} />
                    <Grid container columnGap={2} rowSpacing={3} mt={{ md: 3, xs: 1 }} padding={2} sx={{ backgroundColor: "#f7f7f7", paddingBottom: 5 }}>
                        {
                            tabs[activeTab]?.tab
                        }
                    </Grid>
                </CardContent>
            </Card>
        </Box>


    )
}



const PropertiesTabPanel = () => {
    const [listings, setListings] = useState([]);
    const [listingTeaser, setListingTeaser] = useState([]);
    const [url, setUrl] = useState("");
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [loading, setLoading] = useState(false);
    const user = useSelector(state => state.user.data);
    console.log(user,"user");
    const observer = useRef();

    const lastElementRef = useCallback((node) => {
        if (loading) return;
        if (observer.current) observer.current.disconnect();

        observer.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting && hasMore) {
                setPage(prev => prev + 1);
            }
        });

        if (node) observer.current.observe(node);
    }, [loading, hasMore]);

    const fetchListings = async (pageToFetch) => {
        let membershiptype = user?.membershiptype;
        
        if (pageToFetch <= 1) {
          setLoading(true); // 🔄 Show loading before API call
        }
  try {
    const res = await listingService.getApprovedListing(user?._id, pageToFetch, 9, membershiptype); // page, limit

    if (res && res.success) {
      const newListings = res.data;
      const total = res.noOfEntries || 0;

      if (newListings.length === 0) {
        setHasMore(false); // ✅ Stop further fetching
        return;
      }

      setUrl(res.url);
      setListings(prev => {
        const combined = [...prev, ...newListings];
        const uniqueMap = new Map();
        for (const item of combined) {
          const key = item?._id || item?.listingId || JSON.stringify(item);
          if (!uniqueMap.has(key)) uniqueMap.set(key, item);
        }
        const uniqueList = Array.from(uniqueMap.values());
        setHasMore(uniqueList.length < total);
        return uniqueList;
      });
    } else {
      // Optional: handle unexpected error structure
      setHasMore(false);
      console.warn("Unexpected response format:", res);
    }

  } catch (error) {
    console.error("Failed to fetch listings:", error);
    setHasMore(false); // ✅ Prevent infinite loop on error
  } finally {
    setLoading(false); // ✅ Always turn off loading (even on error)
  }
    };

    const getListingTeaser = async () => {
        try {
        const res = await listingTeaserService.getListingTeaser(user?._id);
        if (res && res.success) {
            setListingTeaser(res.data);
        } else {
            console.error("Failed to fetch listing teaser:", res);
        }
        } catch (error) {
            console.error("Failed to fetch listing teaser:", error);
        }
    }
useEffect(() => {
    if (user?._id) {
        getListingTeaser();
    }
}, [user?._id]);

    useEffect(() => {
        if (!user?._id) return;
        fetchListings(page)
        
    }, [page,user])

    const getSortTimestamp = useCallback((value) => {
        if (value === null || value === undefined) return 0;

        if (typeof value === "number") {
            return value > 1e12 ? value : value * 1000;
        }

        if (typeof value === "string") {
            const numericValue = Number(value);
            if (!Number.isNaN(numericValue)) {
                return numericValue > 1e12 ? numericValue : numericValue * 1000;
            }
        }

        const parsedDate = moment(value);
        return parsedDate.isValid() ? parsedDate.valueOf() : 0;
    }, []);

    const mergedListings = useMemo(() => {
        const teaserItems = (listingTeaser || []).map((item) => ({
            ...item,
            type: "teaser",
            sortDate: getSortTimestamp(item?.created_at)
        }));

        const listingItems = (listings || []).map((item) => ({
            ...item,
            type: "listing",
            sortDate: getSortTimestamp(item?.created_at)
        }));

        return [...teaserItems, ...listingItems].sort((a, b) => b.sortDate - a.sortDate);
    }, [listingTeaser, listings, getSortTimestamp]);

    return (
        <>
            {loading ? (
                <Grid container columnSpacing={3} rowSpacing={3}>
                {[...Array(6)].map((_, index) => (
                    <Grid key={index} item lg={4} md={6} sm={6} xs={12} sx={{ display: { md: 'flex' }, justifyContent: 'center', minWidth: '0' }}>
                        <Skeleton variant="rounded" sx={{ width: "100%", maxWidth: 500, borderRadius: 2 }} height={350} />
                    </Grid>
                ))}
            </Grid>
            ) : (
                <Grid container spacing={3}>
                 {mergedListings.map((e, i) => {
                        const isLastElement = i === mergedListings.length - 1;
                        return (
                            <Grid
                                item
                                lg={4} md={6} sm={6} xs={12}
                                key={`${e.type}-${e._id || i}`}
                                ref={isLastElement ? lastElementRef : null}
                                sx={{ display: { md: 'flex' }, justifyContent: 'center', minWidth: '0' }}
                            >
                                {e.type === "teaser" ? (
                                    <PropertyTeaser data={e} teaserUrl={url} />
                                ) : (
                                    <PropertyCard data={e} url={url} />
                                )}
                            </Grid>
                        );
                    })}
                   
                </Grid>
                
            )}

            {!loading && user?._id && mergedListings?.length === 0 &&
            <Stack alignItems="center" justifyContent="center" spacing={2} sx={{ py: 10, width: "100%" }}>
            <CustomIcon name="building" size={64} style={{ opacity: 0.35 }} />
            <Typography variant="h5" color="text.secondary" fontWeight={600}>
                No Listings Available
            </Typography>
            <Typography variant="body1" color="text.disabled" textAlign="center" maxWidth={400}>
                There are no property listings to display right now. Please check back later for new opportunities.
            </Typography>
        </Stack>
            }
        </>
    )

}

const ProjectTabPanel = () => {
    const [projects, setProjects] = useState([]);
    const [url, setUrl] = useState("");
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [loading, setLoading] = useState(false);
    const [initialLoad, setInitialLoad] = useState(true);
    const observer = useRef();

    const lastElementRef = useCallback(node => {
        if (loading) return;
        if (observer.current) observer.current.disconnect();

        observer.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting && hasMore) {
                setPage(prev => prev + 1);
            }
        });

        if (node) observer.current.observe(node);
    }, [loading, hasMore]);

    const fetchProjects = async (pageNum) => {
        if (loading) return;
        setLoading(true);

        try {
        const res = await listingService.getApprovedProject(pageNum, 6); // page, limit

        if (res && res.success) {
            const newProjects = res.data;
            const total = res.noOfEntries || 0;

            if (newProjects.length === 0) {
            setHasMore(false); // ✅ stop future calls
            return;
            }

            setUrl(res.url);

            setProjects((prev) => {
            const updated = [...prev, ...newProjects];
            setHasMore(updated.length < total); // ✅ use updated length
            return updated;
            });
        } else {
            setHasMore(false); // Fallback
        }
        } catch (err) {
        console.error('Error fetching projects:', err);
        setHasMore(false); // Prevent infinite loop on failure
        } finally {
        setLoading(false);
        setInitialLoad(false);
        }
    
    };

    useEffect(() => {
        fetchProjects(page);
    }, [page]);

    // useEffect(() => {
    //     getProjects();
    // }, [])

    // const getProjects = async () => {
    //     let res = await listingService.getApprovedProject();
    //     if (res && res.success) {
    //         setProjects(res.data);
    //         setUrl(res.url)
    //     }
    // }
    return (<>
        {!initialLoad && !loading && projects.length === 0 ? (
            <Stack alignItems="center" justifyContent="center" spacing={2} sx={{ py: 10, width: "100%" }}>
                <CustomIcon name="building" size={64} style={{ opacity: 0.35 }} />
                <Typography variant="h5" color="text.secondary" fontWeight={600}>
                    No Projects Available
                </Typography>
                <Typography variant="body1" color="text.disabled" textAlign="center" maxWidth={400}>
                    There are no projects to display right now. Please check back later for new opportunities.
                </Typography>
            </Stack>
        ) : (
            <Grid container spacing={3}>
                {projects.map((project, index) => {
                    const isLast = index === projects.length - 1;
                    return (
                        <Grid
                            item
                            lg={4}
                            md={6}
                            sm={6}
                            xs={12}
                            key={project._id || index}
                            sx={{ display: { md: 'flex' }, justifyContent: 'center', minWidth: '0' }}
                            ref={isLast ? lastElementRef : null}
                        >
                            <ProjectCard data={project} url={url} />
                        </Grid>
                    );
                })}

                {loading && hasMore &&
                    [...Array(3)].map((_, index) => (
                        <Grid
                            item
                            lg={4}
                            md={6}
                            sm={6}
                            xs={12}
                            key={`skeleton-${index}`}
                            sx={{ display: { md: 'flex' }, justifyContent: 'center', minWidth: '0' }}
                        >
                            <Skeleton sx={{ width: "238px" }} width={"500px"} height={500} />
                        </Grid>
                    ))
                }
            </Grid>
        )}
    </>

    )

}

const DashBoardCard = ({ title, subtitle, icon, body, toolbarBtn = () => { }, button }) => {
    return (
        <Card sx={{ height: "100%" }}>
            <CardContent>
                <Stack direction={"column"} height={"100%"}>
                    <Stack spacing={"8px"}>
                        <Stack direction={"row"} spacing={{ md: 3, xs: 1.5 }} alignItems={"center"} >
                            {icon ? icon : ""}
                            <Typography variant="mainCardTitle" sx={{ flex: 1 }}>{title}</Typography>
                            {toolbarBtn()}
                            {button ? button : ""}
                        </Stack>
                        {subtitle ? <Typography variant="subtitle1" sx={{ fontSize: "18px", ml: icon ? { md: "72px !important", xs: "44px !important" } : "" }} >{subtitle}</Typography> : ""}
                    </Stack>
                    {
                        body
                    }
                </Stack>
            </CardContent>
        </Card>
    );
}

const ProfileSteps = ({
    title, subtitle, active, done,
    hideBar = false,
    completeValue = 0,
    btnProps = {
        title: "Upload Documents",
        onClick: () => { }
    },
    otherAction = null
}) => {
    return (
        <Box sx={{
            padding: { xs: 2, md: 2 },
            borderRadius: "10px",
            border: "1px solid",
            borderColor: active ? "primary.main" : "divider",

        }}>
            <Stack direction={{ md: "row", xs: "column" }} spacing={{ md: 0, xs: 2 }} >
                <Stack width={{ md: "70%", xs: "100%" }} direction={"column"}>
                    <Stack direction={"row"} spacing={{ md: "20px", xs: "12px" }} >
                        <Box sx={{
                            minWidth: { xs: 16, md: 32 }, height: { xs: 16, md: 32 }, bgcolor: active ? "success.light" : !done ? "background.default" : "success.main", borderRadius: "100%", display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }} >
                            {
                                active ?
                                    <Box sx={{
                                        width: { xs: 8, md: 16 },
                                        height: { xs: 8, md: 16 },
                                        bgcolor: "success.main",
                                        borderRadius: "100%",
                                    }}>
                                    </Box>
                                    :
                                    !done ? "" :
                                        <CustomIcon name="check" sx={{ bgcolor: "#FFF", width: { xs: 8, md: 16 }, height: { xs: 8, md: 16 }, }} />
                            }
                        </Box>
                        <Stack spacing={{ md: 0.5, xs: 0.5 }} >
                            <Typography sx={{ fontSize: "22px", fontWeight: "500", lineHeight: 1 }}>{title}</Typography>
                            <Typography variant="subtitle1"  >{subtitle}</Typography>
                        </Stack>
                    </Stack>
                    {/* {   
                        !active ? "" :
                        !hideBar && 
                        <Box mt={{md:"24px",xs:"12px"}} ml={{xs:"24px",md:"55px"}}>
                            <LinearProgressWithLabel color="success" value={completeValue} />
                        </Box>
                    } */}
                </Stack>
                {
                    !active ? "" :
                        <Stack flex={1} direction={"row"} justifyContent={{ md: "flex-end" }}>
                            {otherAction ? otherAction() :
                                <Button sx={{ ml: { xs: "24px", md: 0 } }} variant="contained" {...btnProps} >
                                    {btnProps.title}
                                </Button>}
                        </Stack>
                }
            </Stack>
        </Box>
    )
}


const OngoingTransactions = ({ setShowNotification, ongoingTransactions, resURL, optinPendingTransactions }) => {

    const navigate = useNavigate();
    const rowPerpage = 2;
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(2);
    const investorId = store.getState().user.data._id;
    if(ongoingTransactions.length > 0){
    ongoingTransactions[0].url = ongoingTransactions?.url
    }
   

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setPage(0);
        setRowsPerPage(parseInt(event.target.value, 10));
    };


    const txnHandleClose = () => {
        setShowNotification(false);
    }
    const tabel = [
        {
            field: "img", headerName: "Asset Img", flex: 1,filter: false,filterable: false,
            renderCell: (params) => {
                return <Stack sx={{ display: "flex", justifyContent: "center", width: "100%", height: "100%", padding: "3px", alignItems: "center" }}>
                    <img
                        src={`${resURL}${params.row.listingImages[0].docUrl}`}
                        alt={'propertyName'}
                        style={{ width: '175px', height: "70px", borderRadius: "10px", objectFit: "cover" }}
                    />
                </Stack>
            }
        },
        {
            field: "projectName", headerName: "Asset Info", flex: 1,filterable: false,
            renderCell: (params) => {
                return <Stack sx={{ display: "flex", flex:"column",justifyContent:"center",alignItems:"center",height: "100%"}}>
                    <Typography style={{ fontSize: "14px" }}>{params.row?.listing?.title}</Typography>
                    <Typography style={{ fontSize: "14px" }}>{params.row.project?.projectName}</Typography>
                    <Typography style={{ marginTop: '0px', color: "#ff2600", fontSize: "14px" }}>{params.row?.listing?.propertyCode}</Typography>
                </Stack>
            }
        },
        {
            field: "amount", headerName: "Commitment Amount", flex: 1.3,
            valueFormatter:(params)=>{
                return`₹${convertToIndianFormat( params, false)||0}`
            }
        },
        { field: 'noOfFracs', headerName: 'Total No of Token', flex: 1 ,
            renderCell: (params) => {
            return <Typography variant="body3">{params.row.noOfFracs ? `${params.row.noOfFracs }-${params.row?.assetclass?.tokenName ? params.row?.assetclass?.tokenName.toUpperCase() : "FRAX"}` : "0"}</Typography>
            }
        },
        {
            field: "expiryDate", headerName: "Time to Confirm ", flex: 1.2,filterable: false,
            renderCell: (params) => {
                return <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: "100%" }}>
                    <TimerComponent expiryDate={params.row.expiryDate} />
                </Box>
            }
        },
        {
             field: "status", headerName: "Action", flex: 1,filterable: false,
            renderCell: (params) => {
                return <Button style={{padding:"8px",fontSize:"13px"}} variant="contained" onClick={() => {

                    if (params.row.status === "CREATED") {
                        navigate(`/dashboard/property/${params.row.listingId}/invest`, { state: { id: params.row.listingId } })
                    }
                }}>Complete Payment
                </Button>
            }

        }

    ]
    const tabel2 = [
        {
            field: 'imgUrl',
            headerName: 'Asset Image',
            flex: 1,
            renderCell: (params) => {
                ''
                return <><div style={{ display: "flex", justifyContent: "center", width: "100%", height: "100%", padding: "2px" }}><img src={params.row.imgUrl} alt="Property" style={{ width: '100px', height: 'auto', borderRadius: "4px" }} /></div>
                </>;
            }
        },
        { field: 'propertyName', headerName: 'Asset Name', flex: 1, },
        // {
        //     field: 'investAmt', headerName: 'Total Amount Invested', flex: 1,
        //     valueFormatter: (params) => {
        //         return `₹${params?.toLocaleString('en-IN')}`
        //     }
        // },
        { field: 'dltNickname', headerName: 'DLT Nickname', flex: 1 },
        { field: 'frax', headerName: 'Total No of Token', flex: 1 ,
            renderCell: (params) => {
                
            return <Typography variant="body3">{params.row.frax ? `${params.row.frax }-${params.row?.assetclass?.tokenName ? params.row?.assetclass?.tokenName?.toUpperCase() : "FRAX"}` : "0"}</Typography>
            }
        },
        // { field: 'rightToOwnerShip', headerName: 'Investment Mode', flex: 1 },
        { field: 'percentInvested', headerName: 'Total % Ownership', flex: 1 },
        {
            field: 'prop',
            headerName: '',
            flex: 1.5,
            renderCell: (params) => {
                const handleClick = () => {
                    if (params.row.saleDeed) {
                        navigate(`/optin/${params.row?.dltAccount?.toLowerCase()}&${investorId}&${params.row?.assetId}`);
                    } else {
                        alert("sale deed not uploaded yet");
                    }
                };

                return (
                    <Button
                        onClick={handleClick}
                        style={{ padding: '12px 15px' }}
                        variant="contained"
                        color="primary"
                    >
                        {'Optin Token'}
                    </Button>
                );
            },
        },
    ].filter(Boolean);


    return (
        <Card sx={{ mt: checkLogin() ? { md: 1, xs: 2 } : { md: 15, xs: 12 }, mx: checkLogin() ? 0 : { xl: "100px", lg: "32px", md: "24px", xs: "16px" }, mb: { xl: 1, lg: 1, md: 1, xs: 0 } }}>
            <CardContent>
                <Stack direction={"column"} height={"100%"}>
                    <Stack direction={"row"} justifyContent={"flex-end"} spacing={2}>
                    <Button variant="contained" size="small" onClick={txnHandleClose}>Close</Button>
                    </Stack>
                    {ongoingTransactions.length > 0 && <DashBoardCard
                        icon={
                            <Box sx={{
                                width: { md: 48, xs: 32 }, height: { md: 48, xs: 32 },
                                bgcolor: "success.light",
                                borderRadius: "100%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center"
                            }}>
                                <PendingActionsIcon sx={{ color: '#64dd17', fontSize: 30, }} />
                            </Box>
                        }


                        title={"Ongoing Transactions"}
                        subtitle={

                            <span style={{ fontSize: '15px' }}>
                                Once you have made the payment for these transactions, Click on 'Confirm Payment' to move forward
                            </span>
                        }
                        body={
                            <Box sx={{
                                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.25)",
                                mt: 2,
                                borderRadius: 1,
                            }}>
                                <ResponsiveDataGridCards
                                  rows={ongoingTransactions}
                                  columns={tabel}
                                  pageSize={5}
                                  rowHeight={80}
                                  renderCard={(row) => (
                                    <Stack spacing={1.25}>
                                      <Box
                                        component="img"
                                        src={`${resURL}${row?.listingImages?.[0]?.docUrl}`}
                                        alt="asset"
                                        sx={{
                                          width: "100%",
                                          height: 140,
                                          borderRadius: 1,
                                          objectFit: "cover",
                                          bgcolor: "background.default",
                                        }}
                                      />
                                      <Stack spacing={0.25}>
                                        <Typography sx={{ fontSize: 14, fontWeight: 600, lineHeight: 1.2 }}>
                                          {row?.listing?.title}
                                        </Typography>
                                        <Typography sx={{ fontSize: 13, color: "text.secondary" }}>
                                          {row?.project?.projectName}
                                        </Typography>
                                        <Typography sx={{ fontSize: 13, color: "#ff2600" }}>
                                          {row?.listing?.propertyCode}
                                        </Typography>
                                      </Stack>

                                      <Stack direction="row" justifyContent="space-between" spacing={1}>
                                        <Typography sx={{ fontSize: 13, color: "text.secondary" }}>Commitment</Typography>
                                        <Typography sx={{ fontSize: 13, fontWeight: 600 }}>
                                          ₹{convertToIndianFormat(row?.amount, false) || 0}
                                        </Typography>
                                      </Stack>

                                      <Stack direction="row" justifyContent="space-between" spacing={1}>
                                        <Typography sx={{ fontSize: 13, color: "text.secondary" }}>Tokens</Typography>
                                        <Typography sx={{ fontSize: 13, fontWeight: 600 }}>
                                          {row?.noOfFracs
                                            ? `${row?.noOfFracs}-${row?.assetclass?.tokenName ? row?.assetclass?.tokenName.toUpperCase() : "FRAX"}`
                                            : "0"}
                                        </Typography>
                                      </Stack>

                                      <Box sx={{ display: "flex", justifyContent: "center" }}>
                                        <TimerComponent expiryDate={row?.expiryDate} />
                                      </Box>

                                      <Button
                                        fullWidth
                                        variant="contained"
                                        onClick={() => {
                                          if (row?.status === "CREATED") {
                                            navigate(`/dashboard/property/${row?.listingId}/invest`, {
                                              state: { id: row?.listingId },
                                            });
                                          }
                                        }}
                                      >
                                        Complete Payment
                                      </Button>
                                    </Stack>
                                  )}
                                />

                            </Box>
                        }
                        // button={<Button variant="contained" size="small" onClick={txnHandleClose}>Close</Button>}
                    />}
                    {optinPendingTransactions.length > 0 &&
                    <DashBoardCard
                        icon={
                            <Box sx={{
                                width: { md: 48, xs: 32 }, height: { md: 48, xs: 32 },
                                bgcolor: "success.light",
                                borderRadius: "100%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center"
                            }}>
                                <PendingActionsIcon sx={{ color: '#64dd17', fontSize: 30, }} />
                            </Box>
                        }


                        title={"Optin Pending"}
                        subtitle={

                            <span style={{ fontSize: '15px' }}>
                                Optin pending for these transactions
                            </span>
                        }
                        body={
                            <Box sx={{
                                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.25)",
                                mt: 2,
                                borderRadius: 1,
                            }}>
                                <ResponsiveDataGridCards
                                  rows={optinPendingTransactions}
                                  columns={tabel2}
                                  pageSize={5}
                                  rowHeight={80}
                                  renderCard={(row) => (
                                    <Stack spacing={1.25}>
                                      <Box
                                        component="img"
                                        src={row?.imgUrl}
                                        alt="asset"
                                        sx={{
                                          width: "100%",
                                          height: 140,
                                          borderRadius: 1,
                                          objectFit: "cover",
                                          bgcolor: "background.default",
                                        }}
                                      />
                                      <Stack spacing={0.5}>
                                        <Typography sx={{ fontSize: 14, fontWeight: 700, lineHeight: 1.2 }}>
                                          {row?.propertyName}
                                        </Typography>
                                        <Stack direction="row" justifyContent="space-between" spacing={1}>
                                          <Typography sx={{ fontSize: 13, color: "text.secondary" }}>DLT Nickname</Typography>
                                          <Typography sx={{ fontSize: 13, fontWeight: 600 }}>{row?.dltNickname || "-"}</Typography>
                                        </Stack>
                                        <Stack direction="row" justifyContent="space-between" spacing={1}>
                                          <Typography sx={{ fontSize: 13, color: "text.secondary" }}>Tokens</Typography>
                                          <Typography sx={{ fontSize: 13, fontWeight: 600 }}>
                                            {row?.frax
                                              ? `${row?.frax}-${row?.assetclass?.tokenName ? row?.assetclass?.tokenName?.toUpperCase() : "FRAX"}`
                                              : "0"}
                                          </Typography>
                                        </Stack>
                                        <Stack direction="row" justifyContent="space-between" spacing={1}>
                                          <Typography sx={{ fontSize: 13, color: "text.secondary" }}>Ownership</Typography>
                                          <Typography sx={{ fontSize: 13, fontWeight: 600 }}>
                                            {row?.percentInvested ?? "-"}
                                          </Typography>
                                        </Stack>
                                      </Stack>

                                      <Button
                                        fullWidth
                                        variant="contained"
                                        onClick={() => {
                                          if (row?.saleDeed) {
                                            navigate(`/optin/${row?.dltAccount?.toLowerCase()}&${investorId}&${row?.assetId}`);
                                          } else {
                                            alert("sale deed not uploaded yet");
                                          }
                                        }}
                                      >
                                        Optin Token
                                      </Button>
                                    </Stack>
                                  )}
                                />

                            </Box>
                        }
                        // button={<Button variant="contained" size="small" onClick={txnHandleClose}>Close</Button>}
                    />}
                </Stack>

            </CardContent>
        </Card>
    );
}

const NotifyPaymentConfirm = ({ setShowNotification, ongoingTransactions, optinPendingTransactions }) => {
    const navigate = useNavigate();
    const transactionCount = ongoingTransactions.length;
    const optinPendingCount = optinPendingTransactions.length;

    const handleNotification = () => {
        if (transactionCount === 1 && ongoingTransactions[0].status === "CREATED" && optinPendingTransactions.length === 0) {
            navigate(`/dashboard/property/${ongoingTransactions[0].listingId}/invest`, { state: { id: ongoingTransactions[0].listingId } })
        }
        else {
            setShowNotification(true);
        }
    }

    return (
        <Card sx={{ mt: checkLogin() ? { md: 3, xs: 2 } : { md: 15, xs: 12 }, mx: checkLogin() ? 0 : { xl: "100px", lg: "32px", md: "24px", xs: "16px" }, mb: { xl: 1, lg: 1, md: 1, xs: 0 }, bgcolor: 'primary.light' }}>
            {/* <CardContent sx={{pb: 15}}> */}
            <Stack direction={"row"} sx={{ p: 2 }} height={"100%"} spacing={3} alignItems={'center'} justifyContent={'start'}>
                <IconButton
                    sx={{
                        width: { md: 24, xs: 32 }, height: { md: 24, xs: 32 },
                        // bgcolor: "success.light",
                        borderRadius: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}

                    color="inherit" onClick={'handleNotificationClick'}>
                    <Badge
                        badgeContent={transactionCount+optinPendingCount}
                        color="error"
                        max={99}
                    >
                        <NotificationsActiveIcon sx={{ color: 'gray', fontSize: '24px' }} />
                    </Badge>
                </IconButton>
                <Typography>You have pending actions related to ongoing transactions</Typography>
                <Button variant="contained" sx={{ py: "0.5rem !important", fontWeight: 500 }} onClick={handleNotification}>View Tasks</Button>
            </Stack>

            {/* </CardContent> */}
        </Card>
    )

}

export const TimerComponent = ({ expiryDate }) => {

    const [time, setTime] = useState("72h : 00m : 00s")

    useEffect(() => {
        getTime();
        let interval = setInterval(() => {
            getTime();
        }, 1000);
        return () => {
            clearInterval(interval);
        }
    }, [])

    const getTime = () => {
        let exDate = moment.unix(expiryDate);
        let today = moment();
        let ms = exDate.diff(today);
        if (ms <= 0) {
            setTime("00h : 00m : 00s");
            return;
        }
        setTime(convertMsToTime(ms))
    }
    return (
        <Box
            sx={{
                py: 1,
                px: 1,
                width: '190px',
                borderRadius: "10px",
                textAlign: 'center',
                bgcolor: 'primary.light'
            }}
        >
            <Typography variant="h5" sx={{ color: "primary.main", fontWeight: 600, padding: '0px 16px' }}>{time}</Typography>
        </Box>
    )
}
